const BYPASS_STORAGE_PREFIX = 'websiteMaintenanceBypass:';
const BYPASS_PARAM = 'preview';
const BYPASS_VALUE = '1';

export function isWebsiteMaintenanceBypassActive(propertyId) {
    if (!propertyId) {
        return false;
    }

    const storageKey = BYPASS_STORAGE_PREFIX + propertyId;
    if (sessionStorage.getItem(storageKey) === '1') {
        return true;
    }

    const params = new URLSearchParams(window.location.search);
    if (params.get(BYPASS_PARAM) === BYPASS_VALUE) {
        sessionStorage.setItem(storageKey, '1');
        return true;
    }

    return false;
}

export function shouldShowWebsiteMaintenance(propertyConfig) {
    if (!propertyConfig?.websiteMaintenanceEnabled) {
        return false;
    }

    return !isWebsiteMaintenanceBypassActive(propertyConfig.propertyId);
}
